import { useTheme } from "styled-components";

interface RatingIconProps {
  minRating: number;
  index: number;
  isActive: boolean;
  onSelect: (index: number) => void;
}

const RatingIcon = ({minRating, index, isActive = false, onSelect}: RatingIconProps) => {
    const {colors}: any = useTheme();

    return (
        <svg
            width="33"
            height="33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{padding: "0 4px"}}
            onClick={() => {
                let v = index + 1;
                if (v < minRating) {
                    v = minRating;
                }
                onSelect(v);
            }}
        >
            <path
                d="M5.41574 22.4152C4.83674 22.7122 4.17974 22.1917 4.29674 21.5272L5.54174 14.4323L0.257236 9.39825C-0.236264 8.92725 0.020236 8.06625 0.681736 7.97325L8.02874 6.92925L11.3047 0.43875C11.6002 -0.14625 12.3997 -0.14625 12.6952 0.43875L15.9712 6.92925L23.3182 7.97325C23.9797 8.06625 24.2362 8.92725 23.7427 9.39825L18.4582 14.4323L19.7032 21.5272C19.8202 22.1917 19.1632 22.7122 18.5842 22.4152L11.9977 19.0312L5.41424 22.4152H5.41574Z"
                fill={isActive ? colors.ratingsActive : colors.ratingsInActive}
            />
        </svg>
    );
};

export default RatingIcon;
